import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { IconBase } from '../internal/IconBase.js';
/**
 * `Moon` — crescent moon.
 * Aria label:    Moon
 * Family:        weather
 * Related:       sun, cloud, cloud-sun, cloud-moon, cloud-rain, cloud-snow
 * Canonical use: moon glyph in weather UI surfaces.
 * Audited 2026-09-20 — no-op (5/5 criteria pass). Moon.
 *
 */
export const Moon = forwardRef(function Moon(props, ref) {
    return (_jsx(IconBase, { ref: ref, ...props, children: _jsx("path", { d: "M21 13 a9 9 0 1 1 -10 -10 a7 7 0 0 0 10 10 z" }) }));
});
//# sourceMappingURL=moon.js.map